/* Canvello v8 — tabs (Task 3.1). <cv-tabs> around a [role=tablist] whose
 * tabs point at [role=tabpanel]s by aria-controls (sections/cv-floor.liquid).
 *
 * WAI-ARIA tabs with automatic activation: click, ←/→ (mirrored in RTL),
 * Home and End. The chosen panel is shown and handed to cv-motion so its
 * images unveil; the others get `hidden`. Theme editor: selecting a tab's
 * block shows it.
 */
(() => {
  if (customElements.get('cv-tabs')) return;

  class CVTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      if (!this.tabs.length) return;
      this.tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => this.select(i));
        tab.addEventListener('keydown', (e) => this.key(e, i));
      });
      this.onBlock = (e) => {
        const i = this.tabs.indexOf(e.target);
        if (i > -1) this.select(i);
      };
      document.addEventListener('shopify:block:select', this.onBlock);
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:block:select', this.onBlock);
    }

    key(e, i) {
      const rtl = getComputedStyle(this).direction === 'rtl';
      const n = this.tabs.length;
      const step = { ArrowRight: rtl ? -1 : 1, ArrowLeft: rtl ? 1 : -1 }[e.key];
      let next = null;
      if (step) next = (i + step + n) % n;
      else if (e.key === 'Home') next = 0;
      else if (e.key === 'End') next = n - 1;
      if (next == null) return;
      e.preventDefault();
      this.select(next);
      this.tabs[next].focus();
    }

    select(i) {
      this.tabs.forEach((tab, j) => {
        const on = j === i;
        tab.setAttribute('aria-selected', String(on));
        tab.tabIndex = on ? 0 : -1;
        const panel = document.getElementById(tab.getAttribute('aria-controls'));
        if (!panel) return;
        // A hidden tab's cards wait in a template (sections/cv-floor.liquid).
        if (on) panel.querySelectorAll('template[data-cv-defer]').forEach((t) => t.replaceWith(t.content));
        if (on && panel.hidden && window.CVMotion) {
          // Unveil the panel's images again as it appears.
          panel.querySelectorAll('[data-cv-u]').forEach((el) => el.removeAttribute('data-cv-u'));
          panel.hidden = false;
          window.CVMotion.scan(panel);
        }
        panel.hidden = !on;
      });
    }
  }

  customElements.define('cv-tabs', CVTabs);
})();
